/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AssigneeDto {
  /** Entra object id. Hand-added pending a swagger regen. */
  id?: string;
  name?: string;
  email?: string;
}

/**
 * The executive VP responsible for a counterparty or broker.
 * Hand-added pending a swagger regen.
 */
export interface VpDto {
  objectId?: string | null;
  displayName?: string | null;
  email?: string | null;
}

export interface UserDto {
  id?: string;
  name?: string;
  email?: string;
  department?: string | null;
}

/**
 * One entry in the counterparty lookup dropdown (ADHO-460).
 * Hand-added pending a swagger regen.
 */
export interface CounterpartyLookupListItem {
  /** Shared warehouse id: BvdIdNumber on the compliance side, CreditCatalystID on the risk side. */
  id?: string;
  name?: string;
}

/**
 * Compliance KYC + credit risk detail for one counterparty (ADHO-460).
 * Hand-added pending a swagger regen.
 *
 * The two warehouse sources are independent, so a counterparty can appear in one and not the
 * other. Check complianceDataAvailable / riskDataAvailable before reading either block: null
 * fields mean "source had no row" when the flag is false, and "source said null" when it is true.
 */
export interface CounterpartyLookupDetails {
  id?: string;
  name?: string | null;
  country?: string | null;

  /** Compliance risk score. */
  riskLevel?: string | null;
  /** KYC check outcome. */
  assessmentStatus?: string | null;
  /** @format date-time */
  assessmentModifiedOn?: string | null;
  complianceDataAvailable?: boolean;

  /** Requesting entity. */
  requestSubsidiary?: string | null;
  requestEmployee?: string | null;
  counterpartyNumber?: string | null;
  counterpartyType?: string | null;
  /** Credit risk check. */
  assessmentType?: string | null;
  creditLimit?: number | null;
  maximumLimit?: number | null;
  currency?: string | null;
  creditRating?: string | null;
  ratingAgency?: string | null;
  specialApproval?: number | null;
  approvalNote?: string | null;
  updateType?: string | null;
  natureOfBusiness?: string | null;
  productsServices?: string | null;
  productType?: string | null;
  note?: string | null;
  /** Date of credit approval/update. @format date-time */
  validFrom?: string | null;
  /** @format date-time */
  validTo?: string | null;
  riskDataAvailable?: boolean;
}

/**
 * Bulk warehouse sync (ADHO-490). Hand-added pending a swagger regen.
 *
 * What the Hub holds for one counterparty, read from the slices that store these values: kycCheck
 * from complianceLifecycle, creditCheck, creditAmount and creditCurrency from creditRiskLifecycle.
 */
export interface WarehouseSyncHubValues {
  kycCheck?: string | null;
  creditCheck?: string | null;
  creditAmount?: number | null;
  creditCurrency?: string | null;
}

/**
 * One counterparty's hub values paired with its warehouse row. Deliberately not a diff: the
 * comparison rules live in components/lifecycle/warehouseSync/utils.ts, shared with the
 * single-counterparty sync dialog. Hand-added pending a swagger regen.
 */
export interface WarehouseSyncPreviewItem {
  /** "counterparty", "broker" or "country". Decides which update endpoint applies the change. */
  entityType?: string;
  /** The Hub entity id, i.e. what the matching update endpoint takes. */
  id?: string;
  /**
   * Which party of the country this item covers. Null for counterparties and brokers, which are one
   * entity and one id. Several items share a country id, so this is part of the item's identity.
   */
  partyType?: CountryPartyType | null;
  /** The name Market Access typed into that party's box. Display only, countries only. */
  partyName?: string | null;
  /** Counterparty name, broker name or country name, whichever this item is. */
  counterpartyName?: string;
  catalystId?: string;
  /** @format date-time */
  syncedAt?: string | null;
  hub?: WarehouseSyncHubValues;
  /** Null when the catalyst id matched neither warehouse source. */
  warehouse?: CounterpartyLookupDetails | null;
  /**
   * False when the Hub has nowhere to put the credit check, amount and currency for this item, so
   * they must not be offered however much the warehouse holds. Only countries say false, and only
   * for parties that are not the TSO or the exchange.
   */
  supportsCredit?: boolean;
}

/** Hand-added pending a swagger regen. */
export interface WarehouseSyncPreviewResponse {
  items?: WarehouseSyncPreviewItem[];
  /**
   * Everything that could carry a Catalyst ID: one per active counterparty, one per active broker,
   * and one per screened party on an active country. Same units as `items`, so
   * items.length + withoutCatalystId === totalCounterparties.
   */
  totalCounterparties?: number;
  /** Skipped because nobody has entered a catalyst id on them yet. */
  withoutCatalystId?: number;
  /** Included, but their catalyst id matched no warehouse row. */
  notFoundInWarehouse?: number;
  /**
   * True when the credit risk view could not be read, so every row is missing its credit check,
   * amount and currency regardless of what the warehouse holds.
   */
  riskSourceUnavailable?: boolean;
}

export type TraderGrantStatus = "Active" | "Expiring" | "Expired" | "Revoked";

export interface TraderGrantDto {
  entityId?: string;
  userObjectId?: string;
  displayName?: string;
  email?: string;
  department?: string | null;
  /** @format date-time */
  grantedAt?: string;
  grantedBy?: string;
  /** @format date-time */
  expiresAt?: string | null;
  /** @format date-time */
  revokedAt?: string | null;
  revokedBy?: string | null;
  isActive?: boolean;
  status?: TraderGrantStatus;
  /** "Trader" or "VP". Hand-added pending a swagger regen. */
  role?: string;
}

export interface GrantTraderAccessRequest {
  entityId: string;
  userObjectId: string;
  displayName: string;
  email?: string;
  department?: string | null;
  /** @format date-time */
  expiresAt?: string | null;
  /** Omit to leave the stored role alone. Hand-added pending a swagger regen. */
  role?: string | null;
}

export interface UpdateTraderAccessExpiryRequest {
  entityId: string;
  userObjectId: string;
  /** @format date-time */
  expiresAt?: string | null;
}

export interface AttachmentMetaDto {
  fileName?: string;
  contentType?: string;
  /** @format int64 */
  sizeBytes?: number;
  /** @format date-time */
  lastModified?: string;
  uploader?: string;
}

export interface CommentDto {
  comment?: string;
  author?: string;
  authorName?: string;
  /** @format date-time */
  timestamp?: string;
}

export interface ComplianceLifecycle {
  kycCheck?: string;
  kycCheckAssignee?: string;
  sanctionScreening?: string;
  sanctionScreeningAssignee?: string;
  kycCheckMft?: string;
  kycCheckMftAssignee?: string;
  creditCheck?: string;
  creditCheckAssignee?: string;
  remitReporting?: string;
  remitReportingAssignee?: string;
  reportingSetup?: string;
  comments?: CommentDto[];
  complete?: boolean;
  signOffNote?: string;
}

export interface CreateCounterpartyRequest {
  tradingTeam?: string;
  contactPersonTradingTeam?: string;
  counterpartyName?: string;
  counterpartyType?: string;
  counterpartyContactName?: string;
  counterpartyContactEmail?: string;
  typeOfTrading?: string;
  productType?: string;
  venue?: string | null;
  agreementType?: string;
  transactionType?: string;
  /** @format double */
  volumeSize?: number;
  unit?: string;
  mandateGranted?: boolean;
  urgent?: boolean;
  contractingEntity?: string | null;
  comment?: CommentDto;
  /** Hand-added pending a swagger regen. */
  vp?: VpDto | null;
  /** Merger-only, hand-added pending a swagger regen. The onboarding request flow refuses it. */
  isMerger?: boolean;
  mergerDescription?: string | null;
  /** The Market Access answers from the merger create form. Ignored unless isMerger. */
  marketAccessLifecycle?: MarketAccessLifecycle | null;
}

export type OnboardingRequestStatus = "Pending" | "Approved" | "Rejected";

/** Which rows an overview returns with respect to mergers. Hand-added pending a swagger regen. */
export type MergerFilter = "exclude" | "only" | "include";

export interface OnboardingRequestDto {
  id?: string;
  status?: OnboardingRequestStatus;
  requestedBy?: string;
  requestedByOid?: string;
  requestedByDisplayName?: string | null;
  requestedByEmail?: string | null;
  /** @format date-time */
  requestedAt?: string;
  payload?: CreateCounterpartyRequest;
  reviewedBy?: string | null;
  /** @format date-time */
  reviewedAt?: string | null;
  reviewerComment?: string | null;
  resultingCounterpartyId?: string | null;
}

export interface ApproveOnboardingRequest {
  payload?: CreateCounterpartyRequest | null;
  comment?: string | null;
}

export interface RejectOnboardingRequest {
  comment?: string;
}

export interface FinanceLifecycle {
  agreementReview?: string;
  agreementReviewAssignee?: string;
  counterpartySetup?: string;
  counterpartySetupAssignee?: string;
  testTrade?: string;
  testTradeAssignee?: string;
  iban?: string;
  ibanAssignee?: string;
  callback?: string;
  callbackAssignee?: string;
  tradeConfirmationSetup?: string;
  comments?: CommentDto[];
  complete?: boolean;
  signOffNote?: string;
}

export interface LegalLifecycle {
  agreementReview?: string;
  agreementReviewAssignee?: string;
  ndaReview?: string;
  ndaReviewAssignee?: string;
  comments?: CommentDto[];
  complete?: boolean;
  clearContractCase?: string | null;
  signOffNote?: string;
}

export interface MarketAccessLifecycle {
  marketAccessAssignee?: string;
  kycCheckOnMft?: string;
  kycCheckOnCounterparty?: string;
  agreementType?: string;
  agreementReview?: string;
  ndaReview?: string;
  mandate?: string;
  collateral?: string;
  tradeCapture?: string;
  tradeConfirmation?: string;
  comments?: CommentDto[];
  complete?: boolean;
  signOffNote?: string;
}

export interface RiskLifecycle {
  mandateApproval?: string;
  mandateApprovalAssignee?: string;
  comments?: CommentDto[];
  complete?: boolean;
  signOffNote?: string;
}

/**
 * Split out of Risk (which keeps the mandate). Shared by counterparties and brokers.
 * Hand-added pending a swagger regen.
 */
export interface CreditRiskLifecycle {
  creditCheck?: string;
  creditCheckAssignee?: string;
  /** @format double */
  creditAmount?: number;
  creditCurrency?: string;
  comments?: CommentDto[];
  complete?: boolean;
  signOffNote?: string;
}

export interface TechLifecycle {
  includedInExistingTradeCapture?: boolean;
  includedInExistingTradeCaptureAssignee?: string;
  newTradeCaptureStatus?: string;
  newTradeCaptureStatusAssignee?: string;
  comments?: CommentDto[];
  complete?: boolean;
  signOffNote?: string;
}

export interface Signatory {
  name: string;
  email: string;
  order: number;
  isCeo: boolean;
  signed: boolean;
  signedBy?: string | null;
  /** @format date-time */
  signedAt?: string | null;
}

export interface SignOff {
  status?: string;
  summary?: string | null;
  signatories: Signatory[];
  createdBy?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  completedAt?: string | null;
  rejectedBy?: string | null;
  /** @format date-time */
  rejectedAt?: string | null;
  rejectionReason?: string | null;
  comments?: CommentDto[];
  /** Hand-added pending a swagger regen (ADHO-551). */
  operationalReadiness?: OperationalReadiness | null;
}

/** One Risk / Treasury / Finance director signing operational readiness. Hand-added (ADHO-551). */
export interface ReadinessSignatory {
  /** "risk" | "treasury" | "finance" */
  department: string;
  name: string;
  email: string;
  signed: boolean;
  signedBy?: string | null;
  /** @format date-time */
  signedAt?: string | null;
}

/**
 * Pre-sign-off by Risk, Treasury and Finance that the entity is ready to trade. When `required`,
 * the VP sign-off cannot be sent until `status` is completed. Hand-added (ADHO-551).
 */
export interface OperationalReadiness {
  required: boolean;
  /** "draft" | "in_progress" | "completed"; the backend sets completed once everyone signed. */
  status?: string;
  signatories: ReadinessSignatory[];
  /** @format date-time */
  completedAt?: string | null;
}

export interface TradingCounterParty {
  id?: string;
  archived?: boolean;
  /** @format date-time */
  archivedAt?: string | null;
  archivedBy?: string | null;
  /** Fixed at create; the backend keeps the stored value. Hand-added pending a swagger regen. */
  isMerger?: boolean;
  mergerDescription?: string | null;
  tradingTeam?: string;
  contactPersonTradingTeam?: string;
  counterpartyName?: string;
  counterpartyType?: string;
  counterpartyContactName?: string;
  counterpartyContactEmail?: string;
  tradingSettlementType?: string;
  productType?: string;
  venue?: string | null;
  agreementType?: string;
  transactionType?: string;
  /** @format double */
  dealVolume?: number;
  unit?: string;
  mandate?: boolean;
  urgent?: boolean;
  contractingEntity?: string | null;
  comments?: CommentDto[];
  progress?: TradingCounterPartyProgress;
  /** Hand-added pending a swagger regen. */
  vp?: VpDto | null;
  /**
   * Shared warehouse id (ADHO-490): BvdIdNumber on the compliance side, CreditCatalystID on the
   * risk side. Set by the lifecycle sync dialog. Hand-added pending a swagger regen.
   */
  creditCatalystId?: string | null;
  /** When warehouse values were last accepted into the lifecycles. @format date-time */
  creditCatalystSyncedAt?: string | null;
  marketAccessLifecycle?: MarketAccessLifecycle;
  complianceLifecycle?: ComplianceLifecycle;
  legalLifecycle?: LegalLifecycle;
  riskLifecycle?: RiskLifecycle;
  creditRiskLifecycle?: CreditRiskLifecycle;
  treasuryLifecycle?: TreasuryLifecycle;
  financeLifecycle?: FinanceLifecycle;
  techLifecycle?: TechLifecycle;
  signOff?: SignOff | null;
}

export interface TradingCounterPartyProgress {
  marketAccess?: string;
  compliance?: string;
  legal?: string;
  risk?: string;
  creditRisk?: string;
  treasury?: string;
  finance?: string;
  tech?: string;
}

export interface TradingCounterPartySummary {
  id?: string;
  counterpartyName?: string;
  tradingTeam?: string;
  contactPersonTradingTeam?: string;
  urgent?: boolean;
  archived?: boolean;
  /** @format date-time */
  archivedAt?: string | null;
  archivedBy?: string | null;
  progress?: TradingCounterPartyProgress;
  /** Email of the Market Access assignee handling this counterparty. */
  marketAccessHandler?: string | null;
  signOffStatus?: string | null;
  /** @format date-time */
  signOffCompletedAt?: string | null;
  /**
   * Hand-added pending a swagger regen. draft, in_progress or completed (ready to trade).
   * Null when readiness is not required, or the row was last saved before the column existed.
   */
  operationalReadinessStatus?: string | null;
  /** Hand-added pending a swagger regen. */
  isMerger?: boolean;
  /**
   * Hand-added pending a swagger regen. Null on entities created before 2026-10-21.
   * @format date-time
   */
  createdAt?: string | null;
  /**
   * Hand-added pending a swagger regen. Joined from the onboarding request, null when created directly.
   * @format date-time
   */
  requestedAt?: string | null;
}

export interface TreasuryLifecycle {
  agreementReview?: string;
  agreementReviewAssignee?: string;
  collateralForm?: string;
  collateralFormAssignee?: string;
  collateralFormStatus?: string;
  collateralFormStatusAssignee?: string;
  amount?: string;
  currency?: string;
  contactPerson?: string;
  cashFlowForecast?: boolean;
  cashFlowForecastAssignee?: string;
  cashFlowVpApproved?: boolean;
  marginCallSystem?: string;
  marginCallSystemAssignee?: string;
  marginCallStatus?: string;
  comments?: CommentDto[];
  complete?: boolean;
  signOffNote?: string;
}

export interface BrokerMarketAccessLifecycle {
  marketAccessAssignee?: string;
  kycCheckOnMft?: string;
  kycCheckOnBroker?: string;
  agreementType?: string;
  agreementReview?: string;
  ndaReview?: string;
  mandate?: string;
  reportingRequirements?: string;
  tradeConfirmation?: string;
  comments?: CommentDto[];
  complete?: boolean;
  signOffNote?: string;
}

export interface BrokerRiskLifecycle {
  mandateReview?: string;
  mandateReviewAssignee?: string;
  comments?: CommentDto[];
  complete?: boolean;
  signOffNote?: string;
}

export interface BrokerFinanceLifecycle {
  agreementReview?: string;
  agreementReviewAssignee?: string;
  brokerSetup?: string;
  brokerSetupAssignee?: string;
  iban?: string;
  ibanAssignee?: string;
  callback?: string;
  callbackAssignee?: string;
  tradeConfirmationSetup?: string;
  comments?: CommentDto[];
  complete?: boolean;
  signOffNote?: string;
}

export interface BrokerProgress {
  marketAccess?: string;
  compliance?: string;
  legal?: string;
  risk?: string;
  creditRisk?: string;
  finance?: string;
}

export interface Broker {
  id?: string;
  archived?: boolean;
  /** @format date-time */
  archivedAt?: string | null;
  archivedBy?: string | null;
  /** Fixed at create; the backend keeps the stored value. Hand-added pending a swagger regen. */
  isMerger?: boolean;
  mergerDescription?: string | null;
  tradingTeam?: string;
  contactPersonTradingTeam?: string;
  brokerName?: string;
  brokerContactName?: string;
  brokerContactEmail?: string;
  tradingSettlementType?: string;
  productType?: string;
  venue?: string | null;
  agreementType?: string;
  transactionType?: string;
  /** @format double */
  dealVolume?: number;
  unit?: string;
  urgent?: boolean;
  contractingEntity?: string | null;
  comments?: CommentDto[];
  progress?: BrokerProgress;
  /** Hand-added pending a swagger regen. */
  vp?: VpDto | null;
  /**
   * Shared warehouse id (ADHO-490): BvdIdNumber on the compliance side, CreditCatalystID on the
   * risk side. Set by the lifecycle sync dialog. Hand-added pending a swagger regen.
   */
  creditCatalystId?: string | null;
  /** When warehouse values were last accepted into the lifecycles. @format date-time */
  creditCatalystSyncedAt?: string | null;
  marketAccessLifecycle?: BrokerMarketAccessLifecycle;
  complianceLifecycle?: ComplianceLifecycle;
  legalLifecycle?: LegalLifecycle;
  riskLifecycle?: BrokerRiskLifecycle;
  creditRiskLifecycle?: CreditRiskLifecycle;
  financeLifecycle?: BrokerFinanceLifecycle;
  signOff?: SignOff | null;
}

export interface BrokerSummary {
  id?: string;
  brokerName?: string;
  tradingTeam?: string;
  contactPersonTradingTeam?: string;
  urgent?: boolean;
  archived?: boolean;
  /** @format date-time */
  archivedAt?: string | null;
  archivedBy?: string | null;
  progress?: BrokerProgress;
  /** Email of the Market Access assignee handling this broker. */
  marketAccessHandler?: string | null;
  signOffStatus?: string | null;
  /** @format date-time */
  signOffCompletedAt?: string | null;
  /** Hand-added pending a swagger regen. See TradingCounterPartySummary. */
  operationalReadinessStatus?: string | null;
  /** Hand-added pending a swagger regen. */
  isMerger?: boolean;
  /**
   * Hand-added pending a swagger regen. Null on entities created before 2026-10-21.
   * @format date-time
   */
  createdAt?: string | null;
  /**
   * Hand-added pending a swagger regen. Joined from the onboarding request, null when created directly.
   * @format date-time
   */
  requestedAt?: string | null;
}

export interface CreateBrokerRequest {
  tradingTeam?: string;
  contactPersonTradingTeam?: string;
  brokerName?: string;
  brokerContactName?: string;
  brokerContactEmail?: string;
  typeOfTrading?: string;
  productType?: string;
  venue?: string | null;
  agreementType?: string;
  transactionType?: string;
  /** @format double */
  volumeSize?: number;
  unit?: string;
  urgent?: boolean;
  contractingEntity?: string | null;
  comment?: CommentDto;
  /** Hand-added pending a swagger regen. */
  vp?: VpDto | null;
  /** Merger-only, see CreateCounterpartyRequest. */
  isMerger?: boolean;
  mergerDescription?: string | null;
  marketAccessLifecycle?: BrokerMarketAccessLifecycle | null;
}

export interface BrokerOnboardingRequestDto {
  id?: string;
  status?: OnboardingRequestStatus;
  requestedBy?: string;
  requestedByOid?: string;
  requestedByDisplayName?: string | null;
  requestedByEmail?: string | null;
  /** @format date-time */
  requestedAt?: string;
  payload?: CreateBrokerRequest;
  reviewedBy?: string | null;
  /** @format date-time */
  reviewedAt?: string | null;
  reviewerComment?: string | null;
  resultingBrokerId?: string | null;
}

export interface ApproveBrokerOnboardingRequest {
  payload?: CreateBrokerRequest | null;
  comment?: string | null;
}

export interface RejectBrokerOnboardingRequest {
  comment?: string;
}

/*
 * Country additions. Hand-added pending a swagger regen. The backend now implements all of this
 * (CounterPartyAppBackend, Models/Country.cs and Models/Lifecycles/Country*.cs), so this block is a
 * mirror of a real contract rather than a proposal. Regenerate from swagger and delete the hand
 * maintenance as soon as the backend is deployed somewhere the generator can reach.
 */

/**
 * The parties a country setup can depend on. Market Access decides which of them exist, and that
 * decision alone drives every downstream lifecycle: no further per-block selection. Rows key on this
 * value rather than on a generated stakeholder id, so a country has at most one of each.
 * See docs/country-additions-plan.md.
 */
export type CountryPartyType =
  | "tso"
  | "exchange"
  | "bank"
  | "clearing_bank"
  | "license_authority"
  | "legal_consultant";

/** One KYC screening. Used for both the checks on a party and the checks on MFT. */
export interface CountryKycCheck {
  partyType?: CountryPartyType;
  /** "initiated" | "approved" | "rejected" | "not_needed" */
  status?: string;
  /** Catalyst ID / BvD id for this party. Per party, not per country. */
  catalystId?: string | null;
  /**
   * When this party was last synced against the warehouse. On the row rather than on the country
   * root because the id it belongs to is, and it covers the credit values written onto
   * creditRiskLifecycle for the same party too.
   * @format date-time
   */
  catalystSyncedAt?: string | null;
}

/** One agreement / legal review, with its own ClearContract case and reviewer. */
export interface CountryAgreement {
  partyType?: CountryPartyType;
  /** "initiated" | "approved" | "rejected" */
  reviewStatus?: string;
  assignee?: string;
  clearContractUrl?: string | null;
}

/** Collateral posted towards one party. Market Access flags it, Treasury fills it in. */
export interface CountryCollateral {
  partyType?: CountryPartyType;
  /** "cash_deposit" | "letter_of_credit" | "bank_guarantee" | "parent_company_guarantee" */
  form?: string;
  assignee?: string;
  amount?: string | null;
  currency?: string | null;
}

/** Treasury's row per bank or clearing bank: the collateral and liquidity terms review. */
export interface CountryTreasuryParty {
  partyType?: CountryPartyType;
  /** "initiated" | "approved" | "rejected" */
  agreementReview?: string;
  agreementReviewAssignee?: string;
  contactPerson?: string | null;
  accountDetails?: string | null;
  currency?: string | null;
}

/** Finance's row per party: agreement review, Business Central setup and IBAN. */
export interface CountryFinanceParty {
  partyType?: CountryPartyType;
  /** "approved" | "rejected" */
  agreementReview?: string;
  /** "initiated" | "completed" | "rejected" */
  businessCentralSetup?: string;
  iban?: string | null;
  assignee?: string;
}

export interface CountryMarketAccessLifecycle {
  marketAccessAssignee?: string;
  /** "needed" | "not_needed" */
  localBranch?: string;
  localBranchName?: string;
  /** Captured when localBranch is "not_needed". */
  contractingEntityName?: string;
  tradingLicense?: string;
  licenseAuthorityName?: string;
  legalConsultancy?: string;
  legalConsultantsName?: string;
  legalConsultantsContactName?: string;
  legalConsultantsContactEmail?: string;
  tso?: string;
  tsoName?: string;
  exchange?: string;
  exchangeName?: string;
  bank?: string;
  bankName?: string;
  clearingBank?: string;
  clearingBankName?: string;
  contractualMftTeam?: string;
  ndaReview?: string;
  mandate?: string;
  collateral?: string;
  tradeCapture?: string;
  /** "initiated" | "completed" | "not_needed" */
  userSetup?: string;
  comments?: CommentDto[];
  complete?: boolean;
  signOffNote?: string;
}

export interface CountryComplianceLifecycle {
  kycChecks?: CountryKycCheck[];
  /** One overall assignee for the whole KYC block, not one per row. */
  kycCheckAssignee?: string;
  kycChecksOnMft?: CountryKycCheck[];
  kycCheckOnMftAssignee?: string;
  reporting?: string;
  reportingAssignee?: string;
  comments?: CommentDto[];
  complete?: boolean;
  signOffNote?: string;
}

export interface CountryLegalLifecycle {
  agreements?: CountryAgreement[];
  comments?: CommentDto[];
  complete?: boolean;
  signOffNote?: string;
}

/**
 * Risk owns the credit amounts for countries, deliberately unlike counterparties and brokers where
 * the check sits on Risk and the amount on ComplianceLifecycle. Compliance renders them read-only.
 */
export interface CountryRiskLifecycle {
  mandateApproval?: string;
  mandateApprovalAssignee?: string;
  comments?: CommentDto[];
  complete?: boolean;
  signOffNote?: string;
}

/**
 * Split out of Risk (which keeps the mandate): one credit line towards the TSO and one towards the
 * exchange. Hand-added pending a swagger regen.
 */
export interface CountryCreditRiskLifecycle {
  creditCheckTso?: string;
  creditCheckTsoAssignee?: string;
  creditAmountTso?: string;
  creditCurrencyTso?: string;
  creditCheckExchange?: string;
  creditCheckExchangeAssignee?: string;
  creditAmountExchange?: string;
  creditCurrencyExchange?: string;
  comments?: CommentDto[];
  complete?: boolean;
  signOffNote?: string;
}

export interface CountryTreasuryLifecycle {
  parties?: CountryTreasuryParty[];
  collaterals?: CountryCollateral[];
  marginCallSystem?: string;
  marginCallSystemAssignee?: string;
  /** "completed" | "not_completed" | "denied". Only meaningful when marginCallSystem is needed. */
  marginCallStatus?: string;
  /** "completed" | "not_completed" */
  cashFlowForecast?: string;
  cashFlowForecastAssignee?: string;
  comments?: CommentDto[];
  complete?: boolean;
  signOffNote?: string;
}

export interface CountryFinanceLifecycle {
  parties?: CountryFinanceParty[];
  testTrade?: string;
  testTradeAssignee?: string;
  /** "initiated" | "completed" | "not_needed" */
  callback?: string;
  callbackAssignee?: string;
  comments?: CommentDto[];
  complete?: boolean;
  signOffNote?: string;
}

export interface CountryTechLifecycle {
  /** "yes" | "no" */
  includedInExistingTradeCapture?: string;
  includedInExistingTradeCaptureAssignee?: string;
  newTradeCaptureStatus?: string;
  newTradeCaptureStatusAssignee?: string;
  comments?: CommentDto[];
  complete?: boolean;
  signOffNote?: string;
}

export interface CountryProgress {
  marketAccess?: string;
  compliance?: string;
  legal?: string;
  risk?: string;
  creditRisk?: string;
  treasury?: string;
  finance?: string;
  tech?: string;
}

export interface Country {
  id?: string;
  archived?: boolean;
  /** @format date-time */
  archivedAt?: string | null;
  archivedBy?: string | null;
  tradingTeam?: string;
  contactPersonTradingTeam?: string;
  countryName?: string;
  /** The requester's proposal. Market Access confirms what is actually needed in its lifecycle. */
  tsoName?: string | null;
  tsoContactName?: string | null;
  tsoContactEmail?: string | null;
  exchangeName?: string | null;
  exchangeContactName?: string | null;
  exchangeContactEmail?: string | null;
  clearingBankName?: string | null;
  clearingBankContactName?: string | null;
  clearingBankContactEmail?: string | null;
  /** Type of trading / settlement. */
  tradingSettlementType?: string;
  productType?: string;
  venue?: string | null;
  transactionType?: string;
  /** @format double */
  dealVolume?: number;
  unit?: string;
  /** Mandate granted. */
  mandate?: boolean;
  urgent?: boolean;
  /** Defaulted and hidden on the request form, still stored. */
  contractingEntity?: string | null;
  /** Open text, the trading team's rationale for the country addition. */
  businessRational?: string | null;
  comments?: CommentDto[];
  progress?: CountryProgress;
  vp?: VpDto | null;
  marketAccessLifecycle?: CountryMarketAccessLifecycle;
  complianceLifecycle?: CountryComplianceLifecycle;
  legalLifecycle?: CountryLegalLifecycle;
  riskLifecycle?: CountryRiskLifecycle;
  creditRiskLifecycle?: CountryCreditRiskLifecycle;
  treasuryLifecycle?: CountryTreasuryLifecycle;
  financeLifecycle?: CountryFinanceLifecycle;
  techLifecycle?: CountryTechLifecycle;
  signOff?: SignOff | null;
}

export interface CountrySummary {
  id?: string;
  countryName?: string;
  tradingTeam?: string;
  contactPersonTradingTeam?: string;
  urgent?: boolean;
  archived?: boolean;
  /** @format date-time */
  archivedAt?: string | null;
  archivedBy?: string | null;
  progress?: CountryProgress;
  /** Email of the Market Access assignee handling this country. */
  marketAccessHandler?: string | null;
  signOffStatus?: string | null;
  /** @format date-time */
  signOffCompletedAt?: string | null;
  /**
   * Hand-added pending a swagger regen. Null on entities created before 2026-10-21.
   * @format date-time
   */
  createdAt?: string | null;
  /**
   * Hand-added pending a swagger regen. Joined from the onboarding request, null when created directly.
   * @format date-time
   */
  requestedAt?: string | null;
}

export interface CreateCountryRequest {
  tradingTeam?: string;
  contactPersonTradingTeam?: string;
  countryName?: string;
  tsoName?: string | null;
  tsoContactName?: string | null;
  tsoContactEmail?: string | null;
  exchangeName?: string | null;
  exchangeContactName?: string | null;
  exchangeContactEmail?: string | null;
  clearingBankName?: string | null;
  clearingBankContactName?: string | null;
  clearingBankContactEmail?: string | null;
  typeOfTrading?: string;
  productType?: string;
  venue?: string | null;
  transactionType?: string;
  /** @format double */
  volumeSize?: number;
  unit?: string | null;
  mandate?: boolean;
  urgent?: boolean;
  contractingEntity?: string | null;
  businessRational?: string | null;
  comment?: CommentDto;
  vp?: VpDto | null;
}

export interface CountryOnboardingRequestDto {
  id?: string;
  status?: OnboardingRequestStatus;
  requestedBy?: string;
  requestedByOid?: string;
  requestedByDisplayName?: string | null;
  requestedByEmail?: string | null;
  /** @format date-time */
  requestedAt?: string;
  payload?: CreateCountryRequest;
  reviewedBy?: string | null;
  /** @format date-time */
  reviewedAt?: string | null;
  reviewerComment?: string | null;
  resultingCountryId?: string | null;
}

export interface ApproveCountryOnboardingRequest {
  payload?: CreateCountryRequest | null;
  comment?: string | null;
}

export interface RejectCountryOnboardingRequest {
  comment?: string;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
  Binary = "application/octet-stream"
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "http://localhost:7071/api";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer"
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key]
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key)
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    // Preserve raw attachment bytes; keep this formatter when regenerating the client.
    [ContentType.Binary]: (input: BodyInit) => input,
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input;
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`
        );
        return formData;
      }, new FormData());
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input)
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {})
      }
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {})
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body)
      }
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const responseToParse = responseFormat ? response.clone() : response;
      const data = !responseFormat
        ? r
        : await responseToParse[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title OpenAPI Document on Azure Functions
 * @version 1.0.0
 * @baseUrl http://localhost:7071/api
 *
 * This is the OpenAPI Document on Azure Functions
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  update = {
    /**
     * No description
     *
     * @name Update
     * @request PUT:/Update
     * @secure
     */
    update: (body: TradingCounterParty, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/Update`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      })
  };
  create = {
    /**
     * No description
     *
     * @name Create
     * @request POST:/Create
     * @secure
     */
    create: (body: CreateCounterpartyRequest, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/Create`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      })
  };
  counterpartyOnboardingRequests = {
    /**
     * No description
     *
     * @name SubmitOnboardingRequest
     * @request POST:/CounterpartyOnboardingRequests
     * @secure
     */
    submit: (body: CreateCounterpartyRequest, params: RequestParams = {}) =>
      this.request<OnboardingRequestDto, any>({
        path: `/CounterpartyOnboardingRequests`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @name ListOnboardingRequests
     * @request GET:/CounterpartyOnboardingRequests
     * @secure
     */
    list: (
      query: {
        /** Pending, Approved, Rejected, or All. */
        status?: OnboardingRequestStatus | "All";
      } = {},
      params: RequestParams = {}
    ) =>
      this.request<OnboardingRequestDto[], any>({
        path: `/CounterpartyOnboardingRequests`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @name ListMyOnboardingRequests
     * @request GET:/CounterpartyOnboardingRequests/mine
     * @secure
     */
    mine: (params: RequestParams = {}) =>
      this.request<OnboardingRequestDto[], any>({
        path: `/CounterpartyOnboardingRequests/mine`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @name ApproveOnboardingRequest
     * @request POST:/CounterpartyOnboardingRequests/{id}/approve
     * @secure
     */
    approve: (
      id: string,
      body: ApproveOnboardingRequest,
      params: RequestParams = {}
    ) =>
      this.request<OnboardingRequestDto, any>({
        path: `/CounterpartyOnboardingRequests/${id}/approve`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @name RejectOnboardingRequest
     * @request POST:/CounterpartyOnboardingRequests/{id}/reject
     * @secure
     */
    reject: (
      id: string,
      body: RejectOnboardingRequest,
      params: RequestParams = {}
    ) =>
      this.request<OnboardingRequestDto, any>({
        path: `/CounterpartyOnboardingRequests/${id}/reject`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      })
  };
  overview = {
    /**
     * No description
     *
     * @name Overview
     * @request GET:/Overview
     * @secure
     */
    overview: (
      query: {
        /** Filter by archived status: active (default), archived, or all. Listing archived or all requires the Admin role. */
        status?: "active" | "archived" | "all";
        /** Mergers in the result: exclude (default), only, or include. Hand-added pending a swagger regen. */
        merger?: MergerFilter;
      } = {},
      params: RequestParams = {}
    ) =>
      this.request<TradingCounterPartySummary[], any>({
        path: `/Overview`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params
      })
  };
  completedOverview = {
    /**
     * No description
     *
     * @name CompletedOverview
     * @request GET:/CompletedOverview
     * @secure
     */
    completedOverview: (
      query: {
        /** Hand-added pending a swagger regen. */
        merger?: MergerFilter;
      } = {},
      params: RequestParams = {}
    ) =>
      this.request<TradingCounterPartySummary[], any>({
        path: `/CompletedOverview`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params
      })
  };
  archive = {
    /**
     * No description
     *
     * @name Archive
     * @request PUT:/Archive
     * @secure
     */
    archive: (
      query: {
        /** Counterparty id to archive */
        id: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<string, any>({
        path: `/Archive`,
        method: "PUT",
        query: query,
        secure: true,
        format: "json",
        ...params
      })
  };
  restore = {
    /**
     * No description
     *
     * @name Restore
     * @request PUT:/Restore
     * @secure
     */
    restore: (
      query: {
        /** Counterparty id to restore */
        id: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<string, any>({
        path: `/Restore`,
        method: "PUT",
        query: query,
        secure: true,
        format: "json",
        ...params
      })
  };
  specific = {
    /**
     * No description
     *
     * @name Specific
     * @request GET:/Specific
     * @secure
     */
    specific: (
      query: {
        /** Id for specific tradecounterparty */
        id: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TradingCounterParty, any>({
        path: `/Specific`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params
      })
  };
  assignees = {
    /**
     * No description
     *
     * @name Assignees
     * @request GET:/Assignees
     * @secure
     */
    assignees: (
      query: {
        /** Name of the group to retrieve assignees from */
        groupName: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<AssigneeDto[], any>({
        path: `/Assignees`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params
      })
  };
  userSearch = {
    /**
     * Tenant-wide user search via Graph. Admin or MarketAccess only.
     *
     * @name UserSearch
     * @request GET:/UserSearch
     * @secure
     */
    userSearch: (
      query: {
        /** Search query (min length 2) */
        q: string;
        /** Max results (default 20, cap 50) */
        top?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<UserDto[], any>({
        path: `/UserSearch`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params
      })
  };
  counterpartyLookupList = {
    /**
     * Every counterparty in the warehouse as id + name, sorted by name. Any internal app role.
     *
     * @name CounterpartyLookupList
     * @request GET:/CounterpartyLookupList
     * @secure
     */
    counterpartyLookupList: (params: RequestParams = {}) =>
      this.request<CounterpartyLookupListItem[], any>({
        path: `/CounterpartyLookupList`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      })
  };
  counterpartyLookupDetails = {
    /**
     * Compliance KYC + credit risk detail for one counterparty. Any internal app role.
     *
     * @name CounterpartyLookupDetails
     * @request GET:/CounterpartyLookupDetails
     * @secure
     */
    counterpartyLookupDetails: (
      query: {
        /** Bureau van Dijk id (BvdIdNumber) of the counterparty to look up */
        id: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<CounterpartyLookupDetails, any>({
        path: `/CounterpartyLookupDetails`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params
      })
  };
  warehouseSyncPreview = {
    /**
     * Every counterparty carrying a catalyst id, paired with its warehouse row. Any internal app
     * role. Read-only: applying the differences goes through the counterparty update endpoint.
     * Hand-added pending a swagger regen.
     *
     * @name WarehouseSyncPreview
     * @request GET:/WarehouseSyncPreview
     * @secure
     */
    warehouseSyncPreview: (params: RequestParams = {}) =>
      this.request<WarehouseSyncPreviewResponse, any>({
        path: `/WarehouseSyncPreview`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      })
  };
  counterpartyTraderGrants = {
    /**
     * List trader grants for a counterparty. Admin or MarketAccess only.
     *
     * @name ListTraderGrants
     * @request GET:/CounterpartyTraderGrants
     * @secure
     */
    list: (
      query: {
        entityId: string;
        includeRevoked?: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.request<TraderGrantDto[], any>({
        path: `/CounterpartyTraderGrants`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * Grant trader access. Idempotent: re-granting un-revokes and updates expiry.
     *
     * @name GrantTraderAccess
     * @request POST:/CounterpartyTraderGrants
     * @secure
     */
    grant: (body: GrantTraderAccessRequest, params: RequestParams = {}) =>
      this.request<TraderGrantDto, any>({
        path: `/CounterpartyTraderGrants`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * Soft-revoke a trader grant.
     *
     * @name RevokeTraderAccess
     * @request DELETE:/CounterpartyTraderGrants
     * @secure
     */
    revoke: (
      query: {
        entityId: string;
        userObjectId: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TraderGrantDto, any>({
        path: `/CounterpartyTraderGrants`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * Update or clear the expiry of an existing trader grant.
     *
     * @name UpdateTraderAccessExpiry
     * @request PATCH:/CounterpartyTraderGrants
     * @secure
     */
    updateExpiry: (
      body: UpdateTraderAccessExpiryRequest,
      params: RequestParams = {}
    ) =>
      this.request<TraderGrantDto, any>({
        path: `/CounterpartyTraderGrants`,
        method: "PATCH",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      })
  };
  brokerTraderGrants = {
    /**
     * List trader grants for a broker. Admin or MarketAccess only.
     *
     * @name ListBrokerTraderGrants
     * @request GET:/BrokerTraderGrants
     * @secure
     */
    list: (
      query: {
        entityId: string;
        includeRevoked?: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.request<TraderGrantDto[], any>({
        path: `/BrokerTraderGrants`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * Grant trader access to a broker. Idempotent.
     *
     * @name GrantBrokerTraderAccess
     * @request POST:/BrokerTraderGrants
     * @secure
     */
    grant: (body: GrantTraderAccessRequest, params: RequestParams = {}) =>
      this.request<TraderGrantDto, any>({
        path: `/BrokerTraderGrants`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * Soft-revoke a broker trader grant.
     *
     * @name RevokeBrokerTraderAccess
     * @request DELETE:/BrokerTraderGrants
     * @secure
     */
    revoke: (
      query: {
        entityId: string;
        userObjectId: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TraderGrantDto, any>({
        path: `/BrokerTraderGrants`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * Update or clear the expiry of an existing broker trader grant.
     *
     * @name UpdateBrokerTraderAccessExpiry
     * @request PATCH:/BrokerTraderGrants
     * @secure
     */
    updateExpiry: (
      body: UpdateTraderAccessExpiryRequest,
      params: RequestParams = {}
    ) =>
      this.request<TraderGrantDto, any>({
        path: `/BrokerTraderGrants`,
        method: "PATCH",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      })
  };
  /**
   * Country trader grants. Hand-added pending a swagger regen, mirroring the Broker endpoints one
   * for one (CounterPartyAppBackend, Functions/CountryTraderAccess.cs).
   */
  countryTraderGrants = {
    /**
     * List trader grants for a country. Admin or MarketAccess only.
     *
     * @name ListCountryTraderGrants
     * @request GET:/CountryTraderGrants
     * @secure
     */
    list: (
      query: {
        entityId: string;
        includeRevoked?: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.request<TraderGrantDto[], any>({
        path: `/CountryTraderGrants`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * Grant trader access to a country. Idempotent.
     *
     * @name GrantCountryTraderAccess
     * @request POST:/CountryTraderGrants
     * @secure
     */
    grant: (body: GrantTraderAccessRequest, params: RequestParams = {}) =>
      this.request<TraderGrantDto, any>({
        path: `/CountryTraderGrants`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * Soft-revoke a country trader grant.
     *
     * @name RevokeCountryTraderAccess
     * @request DELETE:/CountryTraderGrants
     * @secure
     */
    revoke: (
      query: {
        entityId: string;
        userObjectId: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TraderGrantDto, any>({
        path: `/CountryTraderGrants`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * Update or clear the expiry of an existing country trader grant.
     *
     * @name UpdateCountryTraderAccessExpiry
     * @request PATCH:/CountryTraderGrants
     * @secure
     */
    updateExpiry: (
      body: UpdateTraderAccessExpiryRequest,
      params: RequestParams = {}
    ) =>
      this.request<TraderGrantDto, any>({
        path: `/CountryTraderGrants`,
        method: "PATCH",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      })
  };
  listAttachments = {
    /**
     * No description
     *
     * @name ListAttachments
     * @request GET:/ListAttachments
     * @secure
     */
    listAttachments: (
      query: {
        counterpartyId: string;
        lifecycleName: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<AttachmentMetaDto[], any>({
        path: `/ListAttachments`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params
      })
  };
  downloadAttachment = {
    /**
     * No description
     *
     * @name DownloadAttachment
     * @request GET:/DownloadAttachment
     * @secure
     */
    downloadAttachment: (
      query: {
        counterpartyId: string;
        lifecycleName: string;
        fileName: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<Blob, any>({
        path: `/DownloadAttachment`,
        method: "GET",
        query: query,
        secure: true,
        ...params
      })
  };
  uploadAttachment = {
    /**
     * No description
     *
     * @name UploadAttachment
     * @request POST:/UploadAttachment
     * @secure
     */
    uploadAttachment: (
      query: {
        /** Counterparty id */
        counterpartyId: string;
        /** Lifecycle name */
        lifecycleName: string;
      },
      body: File,
      params: RequestParams = {}
    ) =>
      this.request<string, any>({
        path: `/UploadAttachment`,
        method: "POST",
        query: query,
        body: body,
        secure: true,
        format: "json",
        ...params
      })
  };
  deleteAttachment = {
    /**
     * No description
     *
     * @name DeleteAttachment
     * @request DELETE:/DeleteAttachment
     * @secure
     */
    deleteAttachment: (
      query: {
        counterpartyId: string;
        lifecycleName: string;
        fileName: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/DeleteAttachment`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params
      })
  };
  brokerUpdate = {
    /**
     * No description
     *
     * @name BrokerUpdate
     * @request PUT:/BrokerUpdate
     * @secure
     */
    brokerUpdate: (body: Broker, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/BrokerUpdate`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      })
  };
  brokerCreate = {
    /**
     * No description
     *
     * @name BrokerCreate
     * @request POST:/BrokerCreate
     * @secure
     */
    brokerCreate: (body: CreateBrokerRequest, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/BrokerCreate`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      })
  };
  brokerOnboardingRequests = {
    /**
     * No description
     *
     * @name SubmitBrokerOnboardingRequest
     * @request POST:/BrokerOnboardingRequests
     * @secure
     */
    submit: (body: CreateBrokerRequest, params: RequestParams = {}) =>
      this.request<BrokerOnboardingRequestDto, any>({
        path: `/BrokerOnboardingRequests`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @name ListBrokerOnboardingRequests
     * @request GET:/BrokerOnboardingRequests
     * @secure
     */
    list: (
      query: {
        /** Pending, Approved, Rejected, or All. */
        status?: OnboardingRequestStatus | "All";
      } = {},
      params: RequestParams = {}
    ) =>
      this.request<BrokerOnboardingRequestDto[], any>({
        path: `/BrokerOnboardingRequests`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @name ListMyBrokerOnboardingRequests
     * @request GET:/BrokerOnboardingRequests/mine
     * @secure
     */
    mine: (params: RequestParams = {}) =>
      this.request<BrokerOnboardingRequestDto[], any>({
        path: `/BrokerOnboardingRequests/mine`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @name ApproveBrokerOnboardingRequest
     * @request POST:/BrokerOnboardingRequests/{id}/approve
     * @secure
     */
    approve: (
      id: string,
      body: ApproveBrokerOnboardingRequest,
      params: RequestParams = {}
    ) =>
      this.request<BrokerOnboardingRequestDto, any>({
        path: `/BrokerOnboardingRequests/${id}/approve`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @name RejectBrokerOnboardingRequest
     * @request POST:/BrokerOnboardingRequests/{id}/reject
     * @secure
     */
    reject: (
      id: string,
      body: RejectBrokerOnboardingRequest,
      params: RequestParams = {}
    ) =>
      this.request<BrokerOnboardingRequestDto, any>({
        path: `/BrokerOnboardingRequests/${id}/reject`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      })
  };
  brokerOverview = {
    /**
     * No description
     *
     * @name BrokerOverview
     * @request GET:/BrokerOverview
     * @secure
     */
    brokerOverview: (
      query: {
        /** Filter by archived status: active (default), archived, or all. Listing archived or all requires the Admin role. */
        status?: "active" | "archived" | "all";
        /** Mergers in the result: exclude (default), only, or include. Hand-added pending a swagger regen. */
        merger?: MergerFilter;
      } = {},
      params: RequestParams = {}
    ) =>
      this.request<BrokerSummary[], any>({
        path: `/BrokerOverview`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params
      })
  };
  completedBrokerOverview = {
    /**
     * No description
     *
     * @name CompletedBrokerOverview
     * @request GET:/CompletedBrokerOverview
     * @secure
     */
    completedBrokerOverview: (
      query: {
        /** Hand-added pending a swagger regen. */
        merger?: MergerFilter;
      } = {},
      params: RequestParams = {}
    ) =>
      this.request<BrokerSummary[], any>({
        path: `/CompletedBrokerOverview`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params
      })
  };
  brokerArchive = {
    /**
     * No description
     *
     * @name BrokerArchive
     * @request PUT:/BrokerArchive
     * @secure
     */
    brokerArchive: (
      query: {
        /** Broker id to archive */
        id: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<string, any>({
        path: `/BrokerArchive`,
        method: "PUT",
        query: query,
        secure: true,
        format: "json",
        ...params
      })
  };
  brokerRestore = {
    /**
     * No description
     *
     * @name BrokerRestore
     * @request PUT:/BrokerRestore
     * @secure
     */
    brokerRestore: (
      query: {
        /** Broker id to restore */
        id: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<string, any>({
        path: `/BrokerRestore`,
        method: "PUT",
        query: query,
        secure: true,
        format: "json",
        ...params
      })
  };
  brokerSpecific = {
    /**
     * No description
     *
     * @name BrokerSpecific
     * @request GET:/BrokerSpecific
     * @secure
     */
    brokerSpecific: (
      query: {
        /** Id for specific broker */
        id: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<Broker, any>({
        path: `/BrokerSpecific`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params
      })
  };
  brokerAssignees = {
    /**
     * No description
     *
     * @name BrokerAssignees
     * @request GET:/BrokerAssignees
     * @secure
     */
    brokerAssignees: (
      query: {
        /** Name of the group to retrieve assignees from */
        groupName: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<AssigneeDto[], any>({
        path: `/BrokerAssignees`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params
      })
  };
  brokerListAttachments = {
    /**
     * No description
     *
     * @name BrokerListAttachments
     * @request GET:/BrokerListAttachments
     * @secure
     */
    brokerListAttachments: (
      query: {
        brokerId: string;
        lifecycleName: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<AttachmentMetaDto[], any>({
        path: `/BrokerListAttachments`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params
      })
  };
  brokerDownloadAttachment = {
    /**
     * No description
     *
     * @name BrokerDownloadAttachment
     * @request GET:/BrokerDownloadAttachment
     * @secure
     */
    brokerDownloadAttachment: (
      query: {
        brokerId: string;
        lifecycleName: string;
        fileName: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<Blob, any>({
        path: `/BrokerDownloadAttachment`,
        method: "GET",
        query: query,
        secure: true,
        ...params
      })
  };
  brokerUploadAttachment = {
    /**
     * No description
     *
     * @name BrokerUploadAttachment
     * @request POST:/BrokerUploadAttachment
     * @secure
     */
    brokerUploadAttachment: (
      query: {
        /** Broker id */
        brokerId: string;
        /** Lifecycle name */
        lifecycleName: string;
      },
      body: File,
      params: RequestParams = {}
    ) =>
      this.request<string, any>({
        path: `/BrokerUploadAttachment`,
        method: "POST",
        query: query,
        body: body,
        secure: true,
        format: "json",
        ...params
      })
  };
  brokerDeleteAttachment = {
    /**
     * No description
     *
     * @name BrokerDeleteAttachment
     * @request DELETE:/BrokerDeleteAttachment
     * @secure
     */
    brokerDeleteAttachment: (
      query: {
        brokerId: string;
        lifecycleName: string;
        fileName: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/BrokerDeleteAttachment`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params
      })
  };
  /*
   * Country additions. Hand-added pending a swagger regen, mirroring the Broker endpoints one for one.
   * These paths do not exist on the backend yet and will 404 until they do.
   */
  countryOnboardingRequests = {
    /**
     * @name SubmitCountryOnboardingRequest
     * @request POST:/CountryOnboardingRequests
     * @secure
     */
    submit: (body: CreateCountryRequest, params: RequestParams = {}) =>
      this.request<CountryOnboardingRequestDto, any>({
        path: `/CountryOnboardingRequests`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * @name ListCountryOnboardingRequests
     * @request GET:/CountryOnboardingRequests
     * @secure
     */
    list: (
      query: {
        /** Pending, Approved, Rejected, or All. */
        status?: OnboardingRequestStatus | "All";
      } = {},
      params: RequestParams = {}
    ) =>
      this.request<CountryOnboardingRequestDto[], any>({
        path: `/CountryOnboardingRequests`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * @name ListMyCountryOnboardingRequests
     * @request GET:/CountryOnboardingRequests/mine
     * @secure
     */
    mine: (params: RequestParams = {}) =>
      this.request<CountryOnboardingRequestDto[], any>({
        path: `/CountryOnboardingRequests/mine`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * @name ApproveCountryOnboardingRequest
     * @request POST:/CountryOnboardingRequests/{id}/approve
     * @secure
     */
    approve: (
      id: string,
      body: ApproveCountryOnboardingRequest,
      params: RequestParams = {}
    ) =>
      this.request<CountryOnboardingRequestDto, any>({
        path: `/CountryOnboardingRequests/${id}/approve`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * @name RejectCountryOnboardingRequest
     * @request POST:/CountryOnboardingRequests/{id}/reject
     * @secure
     */
    reject: (
      id: string,
      body: RejectCountryOnboardingRequest,
      params: RequestParams = {}
    ) =>
      this.request<CountryOnboardingRequestDto, any>({
        path: `/CountryOnboardingRequests/${id}/reject`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      })
  };
  countryOverview = {
    /**
     * @name CountryOverview
     * @request GET:/CountryOverview
     * @secure
     */
    countryOverview: (
      query: {
        /** Filter by archived status: active (default), archived, or all. Listing archived or all requires the Admin role. */
        status?: "active" | "archived" | "all";
      } = {},
      params: RequestParams = {}
    ) =>
      this.request<CountrySummary[], any>({
        path: `/CountryOverview`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params
      })
  };
  completedCountryOverview = {
    /**
     * @name CompletedCountryOverview
     * @request GET:/CompletedCountryOverview
     * @secure
     */
    completedCountryOverview: (params: RequestParams = {}) =>
      this.request<CountrySummary[], any>({
        path: `/CompletedCountryOverview`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      })
  };
  countrySpecific = {
    /**
     * @name CountrySpecific
     * @request GET:/CountrySpecific
     * @secure
     */
    countrySpecific: (
      query: {
        /** Id for specific country */
        id: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<Country, any>({
        path: `/CountrySpecific`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params
      })
  };
  countryCreate = {
    /**
     * @name CountryCreate
     * @request POST:/CountryCreate
     * @secure
     */
    countryCreate: (body: CreateCountryRequest, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/CountryCreate`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      })
  };
  countryUpdate = {
    /**
     * @name CountryUpdate
     * @request PUT:/CountryUpdate
     * @secure
     */
    countryUpdate: (body: Country, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/CountryUpdate`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      })
  };
  countryArchive = {
    /**
     * @name CountryArchive
     * @request PUT:/CountryArchive
     * @secure
     */
    countryArchive: (
      query: {
        /** Country id to archive */
        id: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<string, any>({
        path: `/CountryArchive`,
        method: "PUT",
        query: query,
        secure: true,
        format: "json",
        ...params
      })
  };
  countryRestore = {
    /**
     * @name CountryRestore
     * @request PUT:/CountryRestore
     * @secure
     */
    countryRestore: (
      query: {
        /** Country id to restore */
        id: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<string, any>({
        path: `/CountryRestore`,
        method: "PUT",
        query: query,
        secure: true,
        format: "json",
        ...params
      })
  };
  countryListAttachments = {
    /**
     * @name CountryListAttachments
     * @request GET:/CountryListAttachments
     * @secure
     */
    countryListAttachments: (
      query: {
        countryId: string;
        lifecycleName: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<AttachmentMetaDto[], any>({
        path: `/CountryListAttachments`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params
      })
  };
  countryDownloadAttachment = {
    /**
     * @name CountryDownloadAttachment
     * @request GET:/CountryDownloadAttachment
     * @secure
     */
    countryDownloadAttachment: (
      query: {
        countryId: string;
        lifecycleName: string;
        fileName: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<File, any>({
        path: `/CountryDownloadAttachment`,
        method: "GET",
        query: query,
        secure: true,
        ...params
      })
  };
  countryDeleteAttachment = {
    /**
     * @name CountryDeleteAttachment
     * @request DELETE:/CountryDeleteAttachment
     * @secure
     */
    countryDeleteAttachment: (
      query: {
        countryId: string;
        lifecycleName: string;
        fileName: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/CountryDeleteAttachment`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params
      })
  };
  countryAssignees = {
    /**
     * @name CountryAssignees
     * @request GET:/CountryAssignees
     * @secure
     */
    countryAssignees: (
      query: {
        /** Name of the group to retrieve assignees from */
        groupName: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<AssigneeDto[], any>({
        path: `/CountryAssignees`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params
      })
  };
}
